<template>
<a-config-provider :locale="locale">
  <div id="app"> 
    <router-view/>
  </div>
</a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  name: "App",
  data(){
    return {
      locale:zhCN
    }
  }
};
</script>

<style>
@font-face {
  font-family: "DIN";
  src: url('https://bbm-2.oss-cn-hangzhou.aliyuncs.com/bbm2.0/file/1450995260917420032.OTF');
}
@font-face {
  font-family: "PingFang";
  src: url('https://bbm-2.oss-cn-hangzhou.aliyuncs.com/bbm2.0/file/1473531826550214656.ttf');
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; 
  color: #2c3e50;
  background: #F4F5F9; 
}
body{
  font-size: 14px !important;
}
input{
  font-size: 14px;
}
.DIN{
  font-family: 'DIN' !important;
}
.PingFang{
  font-family: 'PingFang' !important;
}

/* https://bbm-2.oss-cn-hangzhou.aliyuncs.com/bbm2.0/file/1473531826550214656.ttf  PingFang Regular.ttf */
</style>


<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__close {
    display: none !important;
  }
  .el-image-viewer__actions {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue